export const controlConstants = {
  CHARGING_NETWORK_OPERATOR: "CHARGING_NETWORK_OPERATOR",
  RETAIL: "RETAIL",
  K2: "K2",
};
